import React, { ReactNode } from "react";
import { Form, Formik, FormikProps } from "formik";
import * as Yup from "yup";
import Grid from "@material-ui/core/Grid/Grid";
import CustomDialog from "../../../components/Dialog/CustomDialog";
import CustomTextField from "../../../components/Input/CustomTextField";
import CustomButton from "../../../components/Button/CustomButton";
import { MASK_NUMBER } from "../../../components/Input/MaskConfigurations";

export interface EstimatedTestEffortDialogProps {
  currentEstimatedTestEffort?: number;
  open: boolean;
  onClose: () => void;
  onSubmit: (estimatedTestEffort: string) => void;
}

const EstimatedTestEffortDialog = (props: EstimatedTestEffortDialogProps) => {
  const { open, onClose, onSubmit, currentEstimatedTestEffort } = props;
  const yupValidationSchema = Yup.object().shape({
    estimatedTestEffort: Yup.string().required(),
  });

  return (
    <CustomDialog fullWidth maxWidth="sm" open={open} onClose={onClose}>
      <h2>WAS THE ESTIMATION CORRECT?</h2>
      <Formik
        initialValues={{
          estimatedTestEffort: currentEstimatedTestEffort ? String(currentEstimatedTestEffort) : "",
        }}
        onSubmit={(values): void => {
          onSubmit(values.estimatedTestEffort);
        }}
        validationSchema={yupValidationSchema}
      >
        {(formikProps: FormikProps<{ estimatedTestEffort: string }>): ReactNode => {
          const { errors, handleBlur, handleChange, touched, values } = formikProps;

          return (
            <Form>
              <Grid container direction="column" spacing={3}>
                <Grid item>
                  <CustomTextField
                    autoFocus
                    fullWidth
                    id="estimatedTestEffort"
                    label="Test effort (days)"
                    name="estimatedTestEffort"
                    value={values.estimatedTestEffort}
                    helperText={
                      errors.estimatedTestEffort && touched.estimatedTestEffort ? errors.estimatedTestEffort : ""
                    }
                    error={!!(errors.estimatedTestEffort && touched.estimatedTestEffort)}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    masked={MASK_NUMBER}
                  />
                </Grid>
                <Grid container item direction="row" justify="flex-end">
                  <CustomButton primary text="Confirm" type="submit" />
                </Grid>
              </Grid>
            </Form>
          );
        }}
      </Formik>
    </CustomDialog>
  );
};

export default EstimatedTestEffortDialog;
